import React from 'react';
import {
  FaBriefcase,
  FaLeaf,
  FaChartLine,
  FaHandshake,
  FaBalanceScale,
  FaFlag,
  FaUsers,
} from 'react-icons/fa';
import {
  ProfileCard,
  CardTitle,
  CardContent,
  SectionTitle,
  ProposalList,
  ProposalItem,
  ProposalIcon,
  ProposalText,
} from './styles';

const strengths = [
  { icon: <FaBriefcase />, text: 'Alta credibilidad en el sector empresarial y portuario de San Nicolás.' },
  { icon: <FaLeaf />, text: 'Posicionamiento sostenido como defensor de humedales y planificación a largo plazo.' },
  { icon: <FaChartLine />, text: 'Capacidad de gestión validada por trayectoria empresarial en MoviPort S.A.' },
  { icon: <FaHandshake />, text: 'Pragmatismo político: alianza efectiva entre LLA nacional y Primero San Nicolás local.' },
];

const challenges = [
  { icon: <FaBalanceScale />, text: 'Capitalizar la banca: traducir el respaldo electoral en gestión visible y proyectos aprobados.' },
  { icon: <FaLeaf />, text: 'Sostener la agenda ambiental dentro de un bloque LLA con prioridades nacionales distintas.' },
  { icon: <FaFlag />, text: 'Consolidar identidad política propia post-alianza Primero San Nicolás → LLA.' },
  { icon: <FaUsers />, text: 'Fidelizar a la base militante original de LLA y al voto vecinal de PSN, ahora unificados.' },
];

const PerceptionSection = () => {
  return (
    <ProfileCard>
      <CardTitle>Análisis de Percepción</CardTitle>
      <CardContent>
        <SectionTitle>Fortalezas</SectionTitle>
        <ProposalList>
          {strengths.map((s, i) => (
            <ProposalItem key={i}>
              <ProposalIcon>{s.icon}</ProposalIcon>
              <ProposalText>{s.text}</ProposalText>
            </ProposalItem>
          ))}
        </ProposalList>

        <SectionTitle style={{ marginTop: '1.5rem' }}>Desafíos del mandato</SectionTitle>
        <ProposalList>
          {challenges.map((c, i) => (
            <ProposalItem key={i}>
              <ProposalIcon style={{ color: '#dc3545' }}>{c.icon}</ProposalIcon>
              <ProposalText>{c.text}</ProposalText>
            </ProposalItem>
          ))}
        </ProposalList>
      </CardContent>
    </ProfileCard>
  );
};

export default PerceptionSection;
